export const footerLinks = {
  usefulLinks: {
    head: 'Useful Links',
    links: ['Home', 'About', 'Services', 'Portfolio', 'Contact'],
  },
  servicesLinks: {
    head: 'Our Services',
    links: ['Rhino', 'Matrix', 'blender', 'marvelous ', 'matrix gold'],
  },
};
